module.exports = __webpack_public_path__ + "img/warn.1eca022d.png";